var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
import { forwardRef } from "react";
const SvgCompare = (props, ref) => /*#__PURE__*/React.createElement("svg", _extends({
  xmlns: "http://www.w3.org/2000/svg",
  fill: "currentcolor",
  viewBox: "0 0 32 32",
  ref: ref
}, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
  d: "M24.582 18.611h7.529v7.111h-7.53v6.073l-9.627-9.628 9.628-9.628v6.072ZM7.53 20.257v-6.071H0V7.072h7.53L7.528 1l9.629 9.629-9.628 9.628Z"
})));
const ForwardRef = /*#__PURE__*/forwardRef(SvgCompare);
export default ForwardRef;